import styled, { css } from 'styled-components';

export const ComparePlansModalStyled = styled.div.attrs(() => ({
  className: 'compare-plans-modal',
}))`
  ${({ theme }) => {
    const { colors, media, fonts } = theme;
    return css`
      &.compare-plans-modal {
        background-color: ${colors.primary.white};
        padding: 32px 64px 16px 64px;
        border-radius: 16px;
        width: 93%;
        max-height: 95%;
        display: flex;
        flex-direction: column;
        ${media.desktop.up} {
          max-width: 1270px;
        }

        ${media.mobile.down} {
          padding: 0 0 64px 0;
        }

        .header-container {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 8px;
          align-self: stretch;
          ${media.mobile.down} {
            padding: 16px 16px 0 16px;
          }
          .header {
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: center;
            .btn-close {
              display: block;
              margin: 0 0 0 auto;
              cursor: pointer;
            }
            svg {
              width: 24px;
              height: 24px;
            }
            ${media.mobile.down} {
              svg {
                width: 16px;
                height: 16px;
              }
            }
          }
          .title {
            color: ${colors.primary.gravity};
            font-family: ${fonts.objectSansBold};
            font-size: 30px;
            font-style: normal;
            font-weight: 700;
            line-height: 34px;
            ${media.mobile.down} {
              font-size: 24px;
              line-height: 28px;
            }
          }
          p {
            color: ${colors.primary.gravity};
            font-family: ${fonts.objectSans};
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            ${media.mobile.down} {
              font-size: 14px;
              line-height: 18px;
            }
          }
          .choice-container {
            display: flex;
            align-items: flex-start;
            gap: 16px;
            align-self: stretch;
            padding-bottom: 16px;
            padding-top: 24px;
          }
        }

        .details-container {
          display: flex;
          padding: 16px 0 32px 0;
          align-items: flex-start;
          gap: 16px;
          align-self: stretch;
          ${media.mobile.down} {
            padding: 0 16px 24px 16px;
          }
        }
        .footer {
          border-top: 1px solid ${colors.primary.neutralMedium};
          padding-top: 0;
          margin-top: 16px;
        }
        .footer-note {
          color: ${colors.primary.gravity};
          font-family: ${fonts.objectSans};
          font-size: 10px;
          font-style: normal;
          font-weight: 400;
          line-height: 14px;
        }

        .plans-table {
          overflow-y: scroll;
          overflow-x: hidden;
        }

        .dropdown {
          font-size: 0.75rem;
        }

        .icon--fill-check {
          width: 22px;
          height: 17px;
          fill: ${colors.primary.red};

          // check only does fill via props, forcing to pass this
          // to the children
          & * {
            fill: ${colors.primary.red};
          }
        }

        .icon--fill-minus {
          scale: 1.5;
          & * {
            fill: ${colors.primary.aluminum};
          }
        }
      }
    `;
  }}
`;

export default ComparePlansModalStyled;
